import React, { FC, ReactNode } from "react";
import cn from "classnames";
import { Header } from "../Header";
import { Footer } from "../Footer";

interface Props {
  children: ReactNode;
  className?: string;
  mainClassName?: string;
  isShownHeader?: boolean;
  isShownFooter?: boolean;
}

export const PageWrapper: FC<Props> = ({
  children,
  className,
  mainClassName,
  isShownHeader = true,
  isShownFooter,
}) => {
  return (
    <div className={cn("flex flex-col", className)}>
      <Header isShown={isShownHeader} />
      <main className={mainClassName}>{children}</main>
      <Footer />
    </div>
  );
};
